var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.isMobile)?_c('div',{staticClass:"wave-bottom-img flex-end width-100p foreground"}):_c('div',{staticClass:"line-height-0"},[_c('div',{staticClass:"wave-bottom-img pos-absolute pos-absolute-left-zero pos-absolute-bottom-zero"})])}
var staticRenderFns = []

export { render, staticRenderFns }